import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";

export default function UserListTask({ id }) {
  const [assignees, setAssignees] = useState([]);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Step 1: Get assignees
        const assigneeRes = await axios.get(`${baseurl}getUniqueAssigneesByProjectId/${id}`);
        if (assigneeRes.data.status === "success") {
          setAssignees(assigneeRes.data.assignees);
        }

        // Step 2: Get permissions
        const permissionRes = await axios.get(`${baseurl}getPermissionsByProjectId/${id}`);
        if (permissionRes.data.status === "success") {
          const permissionMap = {};
          permissionRes.data.permissions.forEach((perm) => {
            permissionMap[perm.user_id] = {
              read: perm.read,
              edit: perm.edit,
              delete: perm.delete,
            };
          });
          setPermissions(permissionMap);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (id) fetchData();
  }, [id]);

  const getInitials = (name) => {
    if (!name) return "NA";
    const parts = name.trim().split(" ");
    return parts.length >= 2
      ? parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
      : parts[0].substring(0, 2).toUpperCase();
  };

const adminId = localStorage.getItem("adminID");

  const updatePermission = async (userId, type, newValue) => {
    const payload = {
      user_id: userId,
      permission_type: type,
      status: !!newValue,
      project_id: id,
      admin_id: adminId,
    };

    console.log("Sending permission update payload:", payload);

    try {
      await axios.post(`${baseurl}updatePermission`, payload);
      console.log(`Permission updated: ${userId} - ${type} = ${newValue}`);
    } catch (error) {
      console.error("Error updating permission:", error);
    }
  };

  const handleToggle = (userId, type) => {
    const newValue = !permissions[userId]?.[type];
    setPermissions((prev) => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        [type]: newValue,
      },
    }));
    updatePermission(userId, type, newValue);
  };

  return (
    <>
      <div className="d-flex align-items-center flex-wrap">
        {assignees.slice(0, 8).map((user) => (
          <div
            key={user.id}
            className="rounded-circle bg-white text-dark text-center fw-bold border border-2 me-1 mb-1"
            style={{
              width: "35px",
              height: "35px",
              lineHeight: "35px",
              marginLeft: "-10px",
            }}
          >
            {getInitials(user.full_name)}
          </div>
        ))}

        <div
          className="rounded-circle bg-secondary text-white text-center fw-bold border border-2 me-1 mb-1"
          style={{
            width: "35px",
            height: "35px",
            lineHeight: "35px",
            cursor: "pointer",
            marginLeft: "-10px",
            border: "1px solid #fff",
          }}
          data-bs-toggle="modal"
          data-bs-target="#assigneeModal"
        >
          +
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="assigneeModal"
        tabIndex="-1"
        aria-labelledby="assigneeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content text-dark">
            <div className="modal-header">
              <h5 className="modal-title" id="assigneeModalLabel">
                User Permissions
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {assignees.length === 0 ? (
                <p>No assignees found.</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered align-middle text-center">
                    <thead className="table-light">
                      <tr>
                        <th>User</th>
                        <th>Read</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignees.map((user) => (
                        <tr key={user.id}>
                          <td className="d-flex align-items-center gap-2">
                            <div
                              className="rounded-circle bg-danger text-white fw-bold d-flex align-items-center justify-content-center"
                              style={{ width: "35px", height: "35px", border: "1px solid #fff" }}
                            >
                              {getInitials(user.full_name)}
                            </div>
                            <span>{user.full_name || "Unnamed User"}</span>
                          </td>
                          <td>
                            <div className="form-check form-switch d-inline-block">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={permissions[user.id]?.read || false}
                                onChange={() => handleToggle(user.id, "read")}
                                 
                              />
                            </div>
                          </td>
                          <td>
                            <div className="form-check form-switch d-inline-block">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={permissions[user.id]?.edit || false}
                                onChange={() => handleToggle(user.id, "edit")}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="form-check form-switch d-inline-block">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={permissions[user.id]?.delete || false}
                                onChange={() => handleToggle(user.id, "delete")}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
